module.exports = __webpack_public_path__ + "static/media/dont-eat-for-winter-cover.190f6c37.png";